import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const BACKEND = process.env.REACT_APP_BACKEND_URL;

const LogoContext = createContext({ logoUrl: null, hubName: 'SpillConsult Hub', refreshLogo: () => {} });

export const LogoProvider = ({ children }) => {
  const [logoUrl, setLogoUrl] = useState(null);
  const [hubName, setHubName] = useState('SpillConsult Hub');

  const refreshLogo = useCallback(async () => {
    try {
      const res = await fetch(`${BACKEND}/api/hub/global-logo`);
      if (res.ok) {
        const data = await res.json();
        setLogoUrl(data.logo_url ? `${BACKEND}${data.logo_url}` : null);
        setHubName(data.hub_name || 'SpillConsult Hub');
      }
    } catch {}
  }, []);

  useEffect(() => { refreshLogo(); }, [refreshLogo]);

  return (
    <LogoContext.Provider value={{ logoUrl, hubName, refreshLogo }}>
      {children}
    </LogoContext.Provider>
  );
};

export const useLogo = () => useContext(LogoContext);
